import styled from 'styled-components';

const Header = styled.header`
  margin: 0;
`;

export default Header;
